import { Flex, Spacing } from '@billy/design-system'
import { Fragment, ReactElement } from 'react'

import { ImportedInvoiceApproved } from '../../../../types/importedInvoiceApproved'
import { ImportedInvoicePaymentFlags } from '../../../../types/importedInvoicePaymentFlags'
import { ImportedInvoiceDetailDivider } from './elements/ImportedInvoiceDetailDivider'
import { ImportedInvoiceDetailHistory } from './elements/ImportedInvoiceDetailHistory'
import { ImportedInvoiceDetailLine } from './elements/ImportedInvoiceDetailLine'
import { ImportedInvoiceDetailTotal } from './elements/ImportedInvoiceDetailTotal'
import { ImportedInvoiceGeneralRows } from './elements/ImportedInvoiceGeneralRows'
import { ImportedInvoicePaymentActionButton } from './elements/ImportedInvoicePaymentActionButton'
import { ImportedInvoicePaymentSummary } from './elements/ImportedInvoicePaymentSummary'
import * as Styled from './styles'

interface ImportedInvoiceDetailPanelProps {
  approved: ImportedInvoiceApproved
  paymentFlags: ImportedInvoicePaymentFlags
  uploadDate: string
}

/**
 * The approved invoice's read-only detail. The payment action only shows once the invoice has a
 * payment status, which it gets when it has been posted to accounting.
 */
export const ImportedInvoiceDetailPanel = ({
  approved,
  paymentFlags,
  uploadDate,
}: ImportedInvoiceDetailPanelProps): ReactElement => (
  <Styled.ImportedInvoiceDetailPanelWrapper>
    <ImportedInvoicePaymentActionButton paymentFlags={paymentFlags} />
    <Flex flexDirection="column" gap={Spacing.S24}>
      <ImportedInvoicePaymentSummary approved={approved} paymentStatus={paymentFlags.paymentStatus} />
      <Flex flexDirection="column" gap={Spacing.S12}>
        <ImportedInvoiceGeneralRows approved={approved} />
        <ImportedInvoiceDetailDivider />
        <ImportedInvoiceDetailHistory approvedAt={approved.approvedAt} uploadDate={uploadDate} />
        <ImportedInvoiceDetailDivider />
        {approved.invoiceLines.map((line, lineIndex) => (
          <Fragment key={lineIndex}>
            <ImportedInvoiceDetailLine
              currencyId={approved.currencyId}
              defaultOpen={lineIndex === 0}
              line={line}
              lineIndex={lineIndex}
            />
            <ImportedInvoiceDetailDivider />
          </Fragment>
        ))}
        <ImportedInvoiceDetailTotal approved={approved} />
      </Flex>
    </Flex>
  </Styled.ImportedInvoiceDetailPanelWrapper>
)
